export const name = "WNRS x Red Table Talk Edition"
export const menu = "Inner Circle"
export const edition = "Inner Circle Expansion Pack"
export const crossover = "Red Table Talk"
export const suggestedPlayer = "2+ players"
export const color = {
    primary: {
        main:  '#c10016',
        contrastText: '#ffffff',
    },
    secondary: {
        main:  '#c10016',
    }
}
export const levels = ['Level 1 Perception', 'Level 2 Connection', 'Level 3 Reflection']
export const isExpansion = true

export const backDesc = [
    "There's always another\n layer to anyone\n you think you know"
]

export const level1 = [ // 2 cards
    "What do you think I'm\n most sensitive to?", //
    "What do you think my\n main love language is?"
]

export const level2 = [ // 19 cards
    "What's the hardest truth\n you had to face\n this past year?", //
    "What's brought you the most\n unexpected joy recently?",
    "Who in your life do you feel\n you can be most\n vulnerable with? Explain.", //
    "Have I ever challenged\n your worldview? How so?", //
    "What is a moment in our relationship\n that you felt undeniably loved?",
    "How can I add 1% more\n happiness to your life?", //
    "A perfect day together\n would be _________.",
    "What's the most fun you\n can remember having with\n me recently?",
    "How can I best support\n you in this chapter\n in your life?",
    "What's a feeling you're\n uncomfortable\n sharing with me?",
    "What are you currently\n working through that\n I don't see?",
    "When's the last time\n you felt lucky\n to be you?",
    "When's the last time\n I surprised you?", //
    "When was the last time\n you felt most yourself?",

    "Wild Card Sing your favorite song lyrics\n you can think of off\n the top of your head.\n Both players.",
    "Wild Card Ask me something you think\n is off limits. Both players.",
    "Wild Card Draw your favorite memory with me.\n Both players. Compare.",
    "Wild Card Set an intention for\n this next week. Stick\n to it. (Both players)", // 
    "Wild Card Finish the sentence:\n When I'm hurt I _________.\n Both players."
]

export const level3 = [ // 4 cards
    "What are you\n proudest\n of me for?",
    "What's something we\n should celebrate together?",
    "You've shown me _________\n about myself.", //
    "Wild Card Finish the sentence:\n Thank you for _________.\n Both players."
]